<div>
  <canvas #myCanvas id="drawCanvas"  [width]="canvasWidth" [height]="canvasHeight" [ngStyle]="{'border': '1px solid', 'box-sizing': 'content-box', 'margin': '0 auto'}" class="responsive-canvas"></canvas>
  <br/>
  <div id="bottom-toolbar" style="padding-bottom: 5px;" [ngStyle]="{'text-align': 'center'}">
    <button [disabled]="disableBtnDeleteCanvas" mat-stroked-button color="{{ isConfigSignDefault ? 'primary' : 'gray' }}" class="mr-3"
            (click)="clearCanvas()" type="button">
      <span class="material-icons">brush</span>{{'button.re_draw' | translate}}
    </button>
    <ng-container>
      <button [disabled]="disableBtnDeleteCanvas || disableBtnApplyCanvas" mat-raised-button color="primary" (click)="onSaveCanvas(true)"
              type="button">
        <svg style="margin-right: 0.5rem" width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.98705 9.09594L2.09539 6.20427C1.77039 5.87927 1.24539 5.87927 0.920386 6.20427C0.595386 6.52927 0.595386 7.05427 0.920386 7.37927L4.40372 10.8626C4.72872 11.1876 5.25372 11.1876 5.57872 10.8626L14.3954 2.04594C14.7204 1.72094 14.7204 1.19594 14.3954 0.87094C14.0704 0.54594 13.5454 0.54594 13.2204 0.87094L4.98705 9.09594Z" fill="white"/>
        </svg>
        {{'button.apply' | translate}}
      </button>
    </ng-container>
  </div>
</div>
